// extracted by mini-css-extract-plugin
export default {"scrollContainer":"L97kBRKvSQAR05Rbie0g"};